// 根据运行环境设置 baseUrl
// const baseUrl =
//   process.env.NODE_ENV === 'development'
//     ? 'http://192.168.1.225:7903' // 开发环境
//     : 'https://dbk.0577dxc.com'; // 生产环境

const baseUrl = 'https://dbk.0577dxc.com';

const statusWhiteList = []; // http 的 status 默认放行不才用统一处理的

const uploadImgApi = baseUrl + '/api/market/common/uploadImage'; // 图片上传地址
const excelToStore = baseUrl + '/api/market/order/excelToStore'; // excel上传地址

export { baseUrl, statusWhiteList, uploadImgApi, excelToStore };
